import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { retryOnException } from '@atlaskit/frontend-utilities/retry-operation';
import { WORKED_EVENT } from '../../../common/types/query';
import { packageName, packageVersion } from '../../../common/utils/analytics/package-context';
import { fetchActivitiesWithExperience } from '../../../common/utils/analytics/utils';
import { postResource } from '../../../utils/fetch';
import { GraphQLFragmentError } from '../../../utils/fetch/errors/GraphQLFragmentError';
import { GraphQLJSError } from '../../../utils/fetch/errors/GraphQLJSError';
import { GraphQLNoResultsError } from '../../../utils/fetch/errors/GraphQLNoResults';
import { hydratePolymorphicData } from '../../../utils/hydrator';
import { hydrateConfluenceIcon, hydratedValueToString, hydrateIcon } from '../../../utils/hydrator/utils';
import HydratorConfigClient from '../../hydrator-config-client';
import { ActivityClient } from '../base';
import graphQLErrorHandler from './error-handling';
import { generateGraphQLRequest } from './query';
import { activityRoot, filterInvalidFragments, filtersToMetadata, isEmptyActivitiesWithErrorsResponse, parseRootContainerARI, rollupActivitiesData } from './utils';
var CONFLUENCE_COMMENT_TYPENAMES = ['ConfluenceComment', 'ConfluenceFooterComment', 'ConfluenceInlineComment'];
var IGNORED_HTTP_ERRORS = new Map([
// ignore all 401 errors
[401, [/.*/]], [403, [/Invalid CORS request/]]]);
var IGNORED_ERROR_MESSAGES = ['The operation was aborted.'];
var DEFAULT_TAGS = {
  source: packageName,
  sourcePackageVersion: packageVersion
};
export var ActivityClientV3 = /*#__PURE__*/function (_ActivityClient) {
  _inherits(ActivityClientV3, _ActivityClient);
  var _super = _createSuper(ActivityClientV3);
  function ActivityClientV3(_product, baseUrl, logger, configFetch) {
    var _this;
    _classCallCheck(this, ActivityClientV3);
    _this = _super.call(this, 'v3', _product, {
      'X-ExperimentalApi': 'ActivityV3Api'
    }, baseUrl);
    _defineProperty(_assertThisInitialized(_this), "setProduct", function (product) {
      _this.product = product;
    });
    _defineProperty(_assertThisInitialized(_this), "captureException", function (error, tags) {
      if (_this.clientHandlers) {
        _this.clientHandlers.captureException(error, _objectSpread(_objectSpread({}, DEFAULT_TAGS), tags));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "captureWarning", function (message, tags) {
      if (_this.clientHandlers) {
        _this.clientHandlers.captureWarning(message, _objectSpread(_objectSpread({}, DEFAULT_TAGS), tags));
      }
    });
    _defineProperty(_assertThisInitialized(_this), "fetchHydratorConfig", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.hydratorConfigClient.fetchConfig();
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "handleGraphQLErrors", function (errors) {
      var invalidFragments = [];
      if (Array.isArray(errors)) {
        var _iterator = _createForOfIteratorHelper(errors),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var err = _step.value;
            _this.captureException(new GraphQLJSError(err));
            var invalidFragment = graphQLErrorHandler(err);
            if (invalidFragment) {
              invalidFragments.push(invalidFragment);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return invalidFragments;
      }
      return [];
    });
    _defineProperty(_assertThisInitialized(_this), "fetchActivitiesV3", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(experience, retryMS, filters, activityQueries) {
        var _response$data, _activityRoot, _response$data$activi, _activityRoot2;
        var deduplicateActivities,
          _yield$_this$fetchHyd,
          fragments,
          hydrators,
          response,
          _IGNORED_HTTP_ERRORS$,
          workedOn,
          viewed,
          all,
          activities,
          _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              deduplicateActivities = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
              _context3.next = 3;
              return _this.fetchHydratorConfig();
            case 3:
              _yield$_this$fetchHyd = _context3.sent;
              fragments = _yield$_this$fetchHyd.fragments;
              hydrators = _yield$_this$fetchHyd.hydrators;
              experience.mark('GeneratedQueryWithFilters_start');
              _context3.prev = 7;
              _context3.next = 10;
              return retryOnException( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var request, res, invalidFragments;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      request = generateGraphQLRequest(_this.product, filters, activityQueries, fragments);
                      experience.mark('GeneratedQueryWithFilters_end');
                      experience.mark('FetchedActivities_start');
                      experience.addMetadata({
                        filters: filtersToMetadata(filters)
                      });
                      _context2.next = 6;
                      return postResource(_this.baseUrl, request, retryMS, _objectSpread({}, _this.headers));
                    case 6:
                      res = _context2.sent;
                      experience.mark('FetchedActivities_end');
                      invalidFragments = _this.handleGraphQLErrors(res === null || res === void 0 ? void 0 : res.errors);
                      if (!(invalidFragments.length > 0)) {
                        _context2.next = 12;
                        break;
                      }
                      fragments = filterInvalidFragments(invalidFragments, fragments);
                      throw new GraphQLFragmentError("Missing fragments: [".concat(invalidFragments.toString(), "]"));
                    case 12:
                      return _context2.abrupt("return", res);
                    case 13:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              })), {
                intervalsMS: [0, 0, 0],
                retryOn: function retryOn(err) {
                  return [GraphQLFragmentError].some(function (retriableErr) {
                    return err instanceof retriableErr;
                  });
                },
                captureException: _this.captureException
              });
            case 10:
              response = _context3.sent;
              _context3.next = 17;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](7);
              if (!(!_context3.t0 || !((_IGNORED_HTTP_ERRORS$ = IGNORED_HTTP_ERRORS.get(_context3.t0.statusCode)) !== null && _IGNORED_HTTP_ERRORS$ !== void 0 && _IGNORED_HTTP_ERRORS$.some(function (regExp) {
                return regExp.test(_context3.t0.message);
              })) && !IGNORED_ERROR_MESSAGES.includes(_context3.t0.message))) {
                _context3.next = 17;
                break;
              }
              throw _context3.t0;
            case 17:
              if (!isEmptyActivitiesWithErrorsResponse(response)) {
                _context3.next = 19;
                break;
              }
              throw new GraphQLNoResultsError(response.errors);
            case 19:
              if (!(!response || !((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.activity))) {
                _context3.next = 21;
                break;
              }
              return _context3.abrupt("return", {
                workedOn: [],
                viewed: [],
                all: []
              });
            case 21:
              experience.mark('TransformedActivityItems_start');
              workedOn = transformActivityItem('workedOn', ((_activityRoot = activityRoot(response.data.activity)) === null || _activityRoot === void 0 || (_activityRoot = _activityRoot.workedOn) === null || _activityRoot === void 0 ? void 0 : _activityRoot.edges) || [], hydrators, _this.captureException); // We don't need the activity root function here as viewed only exists on myActivity
              viewed = transformActivityItem('viewed', ((_response$data$activi = response.data.activity) === null || _response$data$activi === void 0 || (_response$data$activi = _response$data$activi.myActivity) === null || _response$data$activi === void 0 || (_response$data$activi = _response$data$activi.viewed) === null || _response$data$activi === void 0 ? void 0 : _response$data$activi.edges) || [], hydrators, _this.captureException);
              all = transformActivityItem('all', ((_activityRoot2 = activityRoot(response.data.activity)) === null || _activityRoot2 === void 0 || (_activityRoot2 = _activityRoot2.all) === null || _activityRoot2 === void 0 ? void 0 : _activityRoot2.edges) || [], hydrators, _this.captureException);
              experience.mark('TransformedActivityItems_end');
              activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
              };
              return _context3.abrupt("return", deduplicateActivities ? rollupActivitiesData(activities) : activities);
            case 28:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[7, 13]]);
      }));
      return function (_x, _x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "fetchActivities", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(retryMS, filters, activityQueries) {
        var deduplicateActivities,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              deduplicateActivities = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : true;
              return _context4.abrupt("return", fetchActivitiesWithExperience(function (experience) {
                return _this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities);
              }, 'v3'));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    _this.clientHandlers = logger;
    _this.hydratorConfigClient = new HydratorConfigClient({
      captureException: _this.captureException,
      captureWarning: _this.captureWarning
    }, _product, configFetch);
    return _this;
  }
  return _createClass(ActivityClientV3);
}(ActivityClient);
function transformActivityItem(query, activities, hydrators, captureException) {
  return activities.reduce(function (acc, item) {
    if (item && item.node && item.node.object && item.node.event) {
      var _item$node = item.node,
        object = _item$node.object,
        event = _item$node.event;
      if (!object.product || !object.type) {
        return acc;
      }
      var containers = [];
      var c = object.contributors || [];
      var contributors = c.reduce(function (contributors, contributor) {
        if (contributor.profile) {
          var _contributor$profile = contributor.profile,
            accountId = _contributor$profile.accountId,
            picture = _contributor$profile.picture;
          contributors.push({
            accountId: accountId,
            name: contributor.profile.name,
            picture: picture
          });
        }
        return contributors;
      }, []);
      var hydratedData = hydratePolymorphicData(hydrators, object.data, captureException);
      if (hydratedData) {
        var _object$data;
        if (hydratedData.key) {
          containers.push({
            name: hydratedValueToString(hydratedData.key, ' ')
          });
        }
        if (hydratedData.containers) {
          containers.push({
            name: hydratedValueToString(hydratedData.containers, ' ')
          });
        }
        var actor = event.actor ? {
          name: event.actor.name,
          picture: event.actor.picture,
          accountId: event.actor.accountId
        } : undefined;

        // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
        var eventType = object.type === 'comment' && event.eventType === WORKED_EVENT.CREATED ? WORKED_EVENT.COMMENTED : event.eventType;
        acc.push({
          actor: actor,
          query: query,
          containers: containers,
          contributors: contributors,
          eventType: eventType,
          object: {
            rootContainerIdentifier: parseRootContainerARI(object.rootContainerId),
            icon: CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? hydrateConfluenceIcon((_object$data = object.data) === null || _object$data === void 0 || (_object$data = _object$data.container) === null || _object$data === void 0 ? void 0 : _object$data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : hydrateIcon(hydratedData.icon, hydratedData.staticFallbacks),
            id: object.id,
            deduplicateId: hydratedValueToString(hydratedData.deduplicateId) || object.id,
            localResourceId: hydratedValueToString(hydratedData.localResourceId),
            name: hydratedValueToString(hydratedData.name, ' '),
            product: object.product,
            subProduct: object.subProduct,
            type: object.type,
            url: hydratedValueToString(hydratedData.url)
          },
          timestamp: event.timestamp
        });
      }
    }
    return acc;
  }, []);
}